<div class="background-container">
    <div class="noise-layer"></div>

    <!-- Diversas formas geométricas flutuando -->
    <div class="shape triangle shape-1"></div>
    <div class="shape hexagon shape-2"></div>
    <div class="shape circle shape-3"></div>
    <div class="shape diamond shape-4"></div>
    <div class="shape triangle shape-5"></div>
    <div class="shape hexagon shape-6"></div>
    <div class="shape circle shape-7"></div>
</div>
